import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Checkbox } from '@/components/ui/checkbox'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { useCurrentUser } from '@/features/auth/state/auth'

import { useNavigate } from 'react-router-dom'
import { useUpdateUserLiAceito } from '@/features/users/services/useUpdateUserLiAceito'

import { FeedbackDialog } from './feedback-dialog'
import { getCleanDomain } from '@/utils/getCleanDomain'
import { ROUTES } from '@/config/routes'
import { hasUserAddress } from '@/features/auth/utils/has-user-address'

export function TermsOfUse() {
  const [accepted, setAccepted] = useState(false)
  const user = useCurrentUser()
  const navigate = useNavigate()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [message, setMessage] = useState<{
    type: 'success' | 'error'
    text: string
  } | null>(null)

  const { mutate: updateUser } = useUpdateUserLiAceito()

  const getPostTermsRoute = () => {
    if (!user) return ROUTES.SIGNIN.path
    if (!hasUserAddress(user) && user.typeCargo !== 'PARCEIRO' && user.typeCargo !== 'GERENTE') {
      return ROUTES.CEP.path
    }
    if (user.typeUser === 'ADMIN') return ROUTES.ADMIN_HOME.path
    return ROUTES.MINUTE_USER.path
  }

  useEffect(() => {
    if (user?.li_aceito) {
      navigate(getPostTermsRoute())
    }
  }, [user, navigate])
  const handleAccept = () => {
    if (!user) {
      setMessage({
        type: 'error',
        text: 'Usuário não autenticado.'
      })
      return
    }

    if (accepted) {
      updateUser(
        { data: { li_aceito: true } },
        {
          onSuccess: () => {
            setMessage({
              type: 'success',
              text: 'Os termos de uso foram aceitos com sucesso!'
            })
            setIsDialogOpen(true) // Abre o modal
            navigate(getPostTermsRoute())
          },
          onError: () => {
            setMessage({
              type: 'error',
              text: 'Houve um erro ao aceitar os termos de uso.'
            })
          }
        }
      )
    } else {
      setMessage({
        type: 'error',
        text: 'Ação Necessária! Por favor, aceite os termos antes de prosseguir.'
      })
    }
  }

  const email = getCleanDomain() // Domínio limpo
  return (
    <div className="min-h-screen flex justify-center items-center ">
      <Card className="w-full max-w-3xl mx-auto">
        <CardHeader>
          <CardTitle>Termos de Uso</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[400px] pr-4">
            <div className="space-y-4 text-sm">
              <h2 className="text-lg font-semibold">1. Aceitação dos Termos</h2>
              <p>
                Ao acessar e utilizar este site web.{email}, você concorda em cumprir e estar vinculado aos seguintes
                Termos de Uso e à nossa Política de Privacidade. Se você não concordar com esses termos, por favor, não
                utilize nosso site.
              </p>

              <h2 className="text-lg font-semibold">2. Modificações dos Termos</h2>
              <p>
                Nos reservamos o direito de modificar estes Termos de Uso a qualquer momento, sem aviso prévio.
                Quaisquer alterações entrarão em vigor imediatamente após sua publicação no site. Recomendamos que você
                reveja periodicamente esta página para se manter atualizado.
              </p>

              <h2 className="text-lg font-semibold">3. Acesso ao Site</h2>
              <p>
                O acesso ao site pode ser temporariamente suspenso por motivos de manutenção ou por causas fora do nosso
                controle. Nós não nos responsabilizamos por eventuais interrupções ou falhas de acesso ao site.
              </p>

              <h2 className="text-lg font-semibold">4. Uso Permitido</h2>
              <p>
                Você concorda em usar este site apenas para fins lícitos e de acordo com as leis aplicáveis. É proibido
                usar o site para:
              </p>
              <ul className="list-disc pl-6">
                <li>Realizar qualquer atividade ilegal ou fraudulenta.</li>
                <li>Transmitir conteúdos prejudiciais, como vírus ou malwares.</li>
                <li>Violar a propriedade intelectual de terceiros.</li>
              </ul>

              <h2 className="text-lg font-semibold">5. Propriedade Intelectual</h2>
              <p>
                Todos os conteúdos presentes no site, incluindo textos, imagens, gráficos, logotipos, vídeos e outros
                materiais, são protegidos por direitos autorais e pertencem ao proprietário do site ou aos seus
                licenciadores. A reprodução, distribuição ou modificação não autorizada desses conteúdos é proibida.
              </p>

              <h2 className="text-lg font-semibold">6. Privacidade e Proteção de Dados</h2>
              <p>
                Nossa Política de Privacidade regula como coletamos, usamos e protegemos seus dados pessoais. Ao
                utilizar nosso site, você concorda com a coleta e uso de seus dados conforme descrito na nossa Política
                de Privacidade.
              </p>
              <p>
                6.1 Além da concordância do tratamento de dados pessoais do usuário, com objetivo de trazer agilidade na
                operação a ser executada, concorda também em conceder acesso ilimitado às informações atinentes ao login
                e senha do e-mail a ser criado pelo aplicativo.
              </p>

              <h2 className="text-lg font-semibold">7. Limitação de Responsabilidade</h2>
              <p>
                Não nos responsabilizamos por quaisquer danos diretos, indiretos, especiais, incidentais ou
                consequenciais decorrentes do uso ou da incapacidade de usar o site, incluindo, mas não se limitando a,
                perda de lucros ou dados.
              </p>

              <h2 className="text-lg font-semibold">8. Links para Sites de Terceiros</h2>
              <p>
                Nosso site pode conter links para sites de terceiros. Não somos responsáveis pelo conteúdo ou pelas
                práticas de privacidade de sites externos. Recomendamos que você leia os termos de uso e a política de
                privacidade de qualquer site de terceiros.
              </p>

              <h2 className="text-lg font-semibold">9. Foro e Legislação Aplicável</h2>
              <p>
                Estes Termos de Uso são regidos pelas Leis e qualquer disputa relacionada a estes termos será resolvida
                exclusivamente pelos tribunais competentes dessa localidade.
              </p>

              <h2 className="text-lg font-semibold">10. Contato</h2>
              <p>
                Caso tenha dúvidas sobre os Termos de Uso ou queira entrar em contato conosco, envie um e-mail para
                [contato@{email}].
              </p>
            </div>
            <FeedbackDialog
              isOpen={isDialogOpen}
              onOpenChange={open => {
                setIsDialogOpen(open)
                if (!open && message?.type === 'success') {
                  // navigate('/cep') // Só navega se fechou e foi sucesso
                }
              }}
              message={message}
            />
          </ScrollArea>
        </CardContent>
        <CardFooter className="flex flex-col items-start space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox id="terms" checked={accepted} onCheckedChange={checked => setAccepted(checked as boolean)} />
            <label
              htmlFor="terms"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Eu li e aceito os termos de uso
            </label>
          </div>
          <Button onClick={handleAccept} disabled={!accepted} className="w-full">
            Aceitar
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
